<template>
  <AppInput
    ref="input"
    v-model="color"
    :rules="rules"
    v-bind="$attrs"
    class="color-picker"
    @input="onInput"
  >
    <template v-slot:append>
      <div
        :style="{ backgroundColor: color }"
        class="color-toggle cursor-pointer flex justify-center items-center"
      >
        <q-icon
          v-if="!color"
          color="grey-1"
          name="colorize"
          size="20px"
        />
        <q-popup-proxy
          transition-hide="scale"
          transition-show="scale"
        >
          <q-color
            v-model="color"
            format-model="hex"
            @input="onInput"
          />
        </q-popup-proxy>
      </div>
    </template>
    <template v-slot:after>
      <slot name="after"/>
    </template>
  </AppInput>
</template>

<script>
import AppInput from 'common/components/AppInput';
import rules from 'common/helpers/rules';

export default {
  name: 'AppColorPicker',
  components: { AppInput },
  props: {
    value: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      color: undefined,
    };
  },
  computed: {
    rules() {
      return [
        rules.HEX_COLOR,
        ...(this.$attrs.rules || []),
      ];
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        this.color = value;
      },
    },
  },
  methods: {
    async onInput(event) {
      await this.$nextTick();
      const isValid = await this.$refs.input.validate();
      if (!isValid) {
        return;
      }
      this.$emit('input', event);
    },
  },
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 1024px) {
  .color {
    &-picker {
      max-width: 100% !important;
    }
  }
}

::v-deep .q-field__append {
  border-left: 1px solid $grey-2;
  padding-left: 8px !important;
}

::v-deep .q-field--outlined .q-field__control {
  padding: 0 8px 0 16px !important;
}

.color {
  &-toggle {
    width: 34px;
    height: 34px;
    border-radius: $radius-6;
  }
}
</style>
